import React, {useEffect} from 'react'
import { fetchAllSCoupons, scouponsSelector } from '../../api/sCouponSlice'
import {fetchAllBrands, brandSelector} from '../../api/brandSlice'

import { Form, Input, Button, Modal,  Checkbox } from 'antd';
import {  useDispatch, useSelector } from 'react-redux';
import Loader from '../../shared/loader'
import Brand from './scoupon'
import { Link } from 'react-router-dom';


export default function Index() {
    const dispatch = useDispatch()

    const { brands, loading } = useSelector(brandSelector)
    const { sAllCoupons } = useSelector(scouponsSelector)

    // console.log(sAllCoupons);

    useEffect(()=>{
        dispatch(fetchAllBrands())
        dispatch(fetchAllSCoupons())
    }, [dispatch])

    let pbrands = brands.filter(item => item.hasPriority === true).sort((a,b)=>a.priority - b.priority)
    
    
    
    return (
        <div className="container md:px-5 px-2 md:py-12 py-4 mx-auto lg:w-4/5 block overflow-hidden ">
                <h2 className='text-[16px]'>E-Vouchers</h2>
            <hr/>
            <div className='md:ml-12 ml-5 md:mt-10'>
            {
                loading? <Loader/> : <Brand brands={pbrands} sAllCoupons={sAllCoupons}/>
            }
            </div>
 
        <Button 
         style={{backgroundColor:'white',
          border:'1px solid #9a4c9d ', 
          color:'#9a4c9d', fontSize:"1rem",
           float:"right",
        }}
          type="primary">
              <Link to="/e-vouchers">
          View More
          </Link>
       </Button>
 <br></br>
 <br></br>

        </div>
    )
}
